import { render } from "./MyConversation.vue?vue&type=template&id=03fce09e&scoped=true"
import script from "./MyConversation.vue?vue&type=script&lang=js"
export * from "./MyConversation.vue?vue&type=script&lang=js"

import "./MyConversation.vue?vue&type=style&index=0&id=03fce09e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fce09e"]])

export default __exports__